if (!customElements.get('bf-premium-hero')) {
  class BfPremiumHero extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.image = this.querySelector('.bf-premium-hero__image');
      this.setReady = this.setReady.bind(this);

      if (this.image && !this.image.complete) {
        this.image.addEventListener('load', this.setReady, { once: true });
        this.image.addEventListener('error', this.setReady, { once: true });
      } else {
        this.setReady();
      }

      if (this.dataset.motion === 'true' && !this.reducedMotion && this.image) {
        this.onPointerMove = this.handlePointerMove.bind(this);
        this.onPointerLeave = this.resetImage.bind(this);
        this.addEventListener('pointermove', this.onPointerMove, { passive: true });
        this.addEventListener('pointerleave', this.onPointerLeave, { passive: true });
      }
    }

    disconnectedCallback() {
      if (this.image) {
        this.image.removeEventListener('load', this.setReady);
        this.image.removeEventListener('error', this.setReady);
      }
      if (this.onPointerMove) this.removeEventListener('pointermove', this.onPointerMove);
      if (this.onPointerLeave) this.removeEventListener('pointerleave', this.onPointerLeave);
    }

    setReady() {
      requestAnimationFrame(() => this.setAttribute('data-ready', ''));
    }

    handlePointerMove(event) {
      if (event.pointerType !== 'mouse') return;
      const bounds = this.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * -3;
      const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * -2;
      this.image.style.transform = `scale(1.008) translate3d(${x}px, ${y}px, 0)`;
    }

    resetImage() {
      this.image.style.transform = '';
    }
  }

  customElements.define('bf-premium-hero', BfPremiumHero);
}
